<template>
  <v-dialog
    v-model="displayProxy"
    max-width="400"
  >
    <v-form
      @submit.prevent="$emit('submit')"
    >
      <v-card>
        <v-card-title>
          {{ title }}
        </v-card-title>
        <v-divider />
        <v-card-text>
          <slot name="body">
            {{ message }}
          </slot>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            type="submit"
          >
            {{ submitLabel }}
          </v-btn>
          <v-btn
            text
            @click="displayProxy = false"
          >
            {{ cancelLabel }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  name: 'BaseDialog',

  props: {
    cancelLabel: {
      default () {
        return this.$t('cancel')
      },
      type: String,
    },
    display: {
      required: true,
      type: Boolean,
    },
    message: {
      default: null,
      type: String,
    },
    submitLabel: {
      default () {
        return this.$t('submit')
      },
      type: String,
    },
    title: {
      required: true,
      type: String,
    },
  },

  computed: {
    displayProxy: {
      get () {
        return this.display
      },
      set (newValue) {
        this.$emit('update:display', newValue)
      },
    },
  },
}
</script>
